import { ActionStatus } from '@parapet/common';

export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_COOKIE = 'SET_COOKIE';

export const AUTH_USER = 'AUTH_USER';
export const AUTH_COMPANY_USER = 'AUTH_COMPANY_USER';
export const AUTH_COMPANY_USER_SUCCESS = 'AUTH_COMPANY_USER_SUCCESS';
export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS';

export const LOG_OUT_USER = 'LOG_OUT_USER';

export interface SetAuthToken {
  type: typeof SET_AUTH_TOKEN;
  token: string;
  expires: string;
  legacyUrl: string;
}

export interface SetCookie {
  type: typeof SET_COOKIE;
  cookie: string;
}

interface AbstractAuthUser {
  email: string;
  phone: string;
  authType: 'email' | 'password';
  password: string;
}

export interface AuthUser extends AbstractAuthUser {
  type: typeof AUTH_USER;
  company?: string;
  callback?: string;
}

export interface AuthCompanyUser extends AbstractAuthUser {
  type: typeof AUTH_COMPANY_USER;
  company: string;
  callback: string;
}

export interface AuthCompanyUserSuccess {
  type: typeof AUTH_COMPANY_USER_SUCCESS;
  url: string;
}

export interface AuthUserSuccess {
  type: typeof AUTH_USER_SUCCESS;
  token: string;
}

interface AbstractAuthStatus {
  status: ActionStatus;
}

export interface SetAuthStatus extends AbstractAuthStatus {
  type: typeof SET_AUTH_STATUS;
}

export interface LogOutUser {
  type: typeof LOG_OUT_USER;
}

export type ActionTypes =
  | SetAuthToken
  | SetCookie
  | AuthUser
  | AuthCompanyUser
  | AuthCompanyUserSuccess
  | AuthUserSuccess
  | SetAuthStatus
  | LogOutUser;
